import keyMirror from '../../util/keyMirror';

export default keyMirror('Products', [
    'LOAD_PRODUCTS_START',
    'LOAD_PRODUCTS_SUCCESS',
    'LOAD_PRODUCTS_FAIL'
]);
